// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAjjyzcZSUk26uq25fbwKkQhd-S3tdYtHU",
  authDomain: "metrohomeservices-8950a.firebaseapp.com",
  projectId: "metrohomeservices-8950a",
  storageBucket: "metrohomeservices-8950a.appspot.com",
  messagingSenderId: "732452877882",
  appId: "1:732452877882:web:c2268fd5d0cebb2aa22703",
  measurementId: "G-GXEK4FV8T7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);